"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const email = text => {
  if (text.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return true;else return false;
};
const objectId = text => {
  if (text.match(/^(?=.*[0-9])(?=.*[A-Za-z])([a-zA-Z0-9]){10}$/)) return true;else return false;
};
exports.default = {
  email,
  objectId
};